export const isDefined = (arg) => arg !== undefined && arg !== null;
